<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'OFWCA'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-ofwca-details-view *ngIf="!modify" [ofwca]="ofwca" (modifyClicked)="modify = true" (ofwcaChanged)="loadOfwca()"></app-ofwca-details-view>
    <app-ofwca-add *ngIf="modify" [ofwca]="ofwca" (closeModification)="modify = false; loadOfwca()"></app-ofwca-add>
  </mat-tab>
<!--  <mat-tab label="Umowy">-->
<!--    <ng-template matTabContent>-->
<!--&lt;!&ndash;      <button [disabled]="!(userPermissions | async).contract.create" mat-stroked-button color="primary" class="add-button" (click)="addContract()"><mat-icon>add</mat-icon> Dodaj umowę</button>&ndash;&gt;-->

<!--      <app-contract-list [excludeColumns]="[]" [contracts]="contracts" (contractDeleted)="loadContracts()"></app-contract-list>-->
<!--    </ng-template>-->
<!--  </mat-tab>-->
  <mat-tab label="Umowy z pracownikiem">
    <ng-template matTabContent>
      <button [disabled]="!hasContracts" mat-stroked-button [matMenuTriggerFor]="menu" [class.spinner]="isLoadingContracts" aria-label="Menu" color="primary">
        <mat-icon>settings</mat-icon> Wygeneruj
      </button>

      <mat-menu #menu="matMenu" class="ofwcadropdown">
        <button
          [disabled]="!(userPermissions | async).ofwca.delete || generatingDocument"
          [class.spinner]="generatingDocument" (click)="generateContractWithEmployee(false)"
          mat-menu-item
        ><mat-icon>content_copy</mat-icon> <span> Wygeneruj wszystkie umowy z pracownikiem</span></button>
        <button
          [disabled]="!(userPermissions | async).ofwca.delete || generatingDocument"
          [class.spinner]="generatingDocument" (click)="generateContractWithEmployee(true)"
          mat-menu-item
        ><mat-icon>content_copy</mat-icon> <span> Wygeneruj nowe umowy z pracownikiem</span></button>
      </mat-menu>

      <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary" class="add-button" (click)="addContractWithEmployee()"><mat-icon>add</mat-icon> Dodaj dokument</button>

      <app-contract-list [displayedColumnIn]="['partner', 'type', 'number', 'createdDate', 'status', 'company', 'contractWithEmployee', 'released', 'releasedDate',  'returned', 'returnedDate']" [contracts]="contractsRegistration" [ofwcaId]="ofwcaId" (contractDeleted)="loadContractsRegistration()"></app-contract-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <div fxLayout="row">
        <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary" class="add-button" (click)="addDocument()"><mat-icon>add</mat-icon> Dodaj dokument</button>
        <button [disabled]="!(userPermissions | async).document.write" [matMenuTriggerFor]="menudownload" mat-stroked-button color="primary" class="add-button"><mat-icon>list</mat-icon> Pobierz dokumenty</button>
      </div>
      <div fxLayout="row">

      </div>
      <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="start start">
        <app-dict
          [multiple]="false" [dictType]="'file_type'"
          [label]="'Typ dokumentu'" appearance="standard" class="view-select"
          [onlyKeys] = DOCUMENRS_TYPES
          [control]="typeControl"
          (selectedDict)="loadDocuments(documentsViewControl.value,$event?.id)"
        ></app-dict>

          <div fxLayout="row">
            <mat-form-field appearance="standard" class="view-select">
              <mat-label>Widok</mat-label>
              <mat-select [formControl]="documentsViewControl">
                <mat-option [value]="ACTIVE_DOCUMENTS">Aktywne</mat-option>
                <mat-option [value]="ARCHIVE_DOCUMENTS">Archiwum</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

<!--        <button (click)="filtrReset()" mat-stroked-button class="add-button"  color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>-->

      </div >
      <app-document-list [excludeColumns]="['partnerOrOfwca', 'deviceProtocolDate']" [documents]="documents" (changed)="loadDocuments(this.documentsViewControl.value)"></app-document-list>
    </ng-template>
  </mat-tab>

  <mat-menu #menudownload="matMenu">
    <button
      (click)="downloadDocument(true, true)"
      mat-menu-item>
      <mat-icon>download</mat-icon> <span> Komplet </span></button>
    <button
      (click)="downloadDocument(true , false)"
      mat-menu-item>
      <mat-icon>download</mat-icon> <span> Upoważnienia </span></button>
    <button
    (click)="downloadDocument(false, true)"
    mat-menu-item>
      <mat-icon>download</mat-icon> <span> Pełnomocnictwa </span></button>
  </mat-menu>

  <mat-tab label="Rejestracje">
    <ng-template matTabContent>
      <div fxLayout="column">
        <div fxLayout="row">
<!--          <button [disabled]="!(userPermissions | async).registration.create" mat-stroked-button color="primary" class="add-button"-->
<!--                  (click)="addRegistration()"><mat-icon>add</mat-icon> Dodaj rejestrację</button>-->
          <button [disabled]="!(userPermissions | async).registration.create" mat-stroked-button color="primary" class="add-button"
                  (click)="addMultipleRegistration()"><mat-icon>playlist_add</mat-icon> Dodaj wiele rejestracji</button>
        </div>

        <div fxLayout="row">
          <mat-form-field appearance="standard" class="view-select">
            <mat-label>Widok</mat-label>
            <mat-select [formControl]="registrationsViewControl">
              <mat-option [value]="ACTIVE_VIEW">Aktywne</mat-option>
              <mat-option [value]="ARCHIVE_VIEW">Archiwum</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <app-all-registrations-list
          *ngIf="registrationsViewControl.value === ACTIVE_VIEW"
          [ofwcaId]="ofwcaObject.uuid" [reloadList]="registrationsChanged" [disableFilters]="true"
          [disableBreadcrumb]="true" [embeddedView]="true"
          [excludeColumns]="['ofwca_just', 'ofwcaLastName', 'insuranceCompany_just','agreedToDeregister', 'ofwca', 'passedExam100p', 'passedExam40p',
        'signedUpForAnExam', 'examPassed', 'sentToRegister', 'deregistrationPack']"
          [statusKeys]="ACTIVE_STATUSES"
          [iddTrainingObject]="iddTrainingObject"
        ></app-all-registrations-list>

        <app-all-registrations-list
          *ngIf="registrationsViewControl.value === ARCHIVE_VIEW"
          [ofwcaId]="ofwcaObject.uuid" [reloadList]="registrationsChanged" [disableFilters]="true"
          [disableBreadcrumb]="true" [embeddedView]="true"
          [excludeColumns]="['ofwca_just', 'ofwcaLastName', 'insuranceCompany_just','agreedToDeregister', 'ofwca', 'passedExam100p', 'passedExam40p',
        'signedUpForAnExam', 'examPassed', 'sentToRegister', 'deregistrationPack', 'requirementMet']"
          [statusKeys]="ARCHIVE_STATUSES"
        ></app-all-registrations-list>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Hiperio" *ngIf="ofwcaObject?.hiperioAgencyUnitsUuid">

    <ng-template matTabContent >
      <button     [disabled]="!(userPermissions | async).registration.read "
                  mat-stroked-button color="primary" class="add-button"
                  (click)="sendTestAccessForm()"><mat-icon>add</mat-icon> Zawnioskuj o dostępy testowe</button>

      <button    *ngIf="ofwcaObject?.hiperioAgencyUnitsUuid"
                  [disabled]="!(userPermissions | async)?.hiperio.write || !parameter"
                  [class.spinner]="!parameter && (userPermissions | async).hiperio.write"
                  mat-stroked-button color="primary" class="add-button"
                  (click)="changeParameter()"><mat-icon>edit</mat-icon> Zmiana parametrów</button>
      <button    *ngIf="ofwcaObject?.hiperioAgencyUnitsUuid"
                 [disabled]="!(userPermissions | async)?.registration.read "
                 mat-stroked-button color="primary" class="add-button"
                 (click)="concludeParameter()"><mat-icon>edit</mat-icon> Zawnioskuj o zmianę loginu</button>
      <app-hiperio-registration-config *ngIf="(userPermissions | async)?.registration.read"   [hiperioRegistrationConfigs]="hiperioRegistrationConfig" ></app-hiperio-registration-config>
    </ng-template>
  </mat-tab>
  <mat-tab label="KRK">
    <ng-template matTabContent>
      <app-krk-list [ofwca]="ofwca"></app-krk-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Identyfikatory" >
    <ng-template matTabContent>
      <div fxLayout="column">
        <div fxLayout="row">
           <button *ngIf="(userPermissions | async).ofwca_access_report.read_report" [disabled]="!(userPermissions | async).ofwca_access_report.read_report"  mat-raised-button class="add-button" (click)="downloadReport()"><mat-icon>download</mat-icon>  Pobierz raport loginów</button>
        </div>

          <app-all-identifiers-list
            *ngIf="ofwcaObject"
            [disableBreadcrumb]="true"
            [disableFilters]="false"
            [ofwcaId]="ofwcaObject.uuid"
            [excludeColumns]="['ofwca']"
            [embeddedView]="true"
          ></app-all-identifiers-list>

      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Egzaminy/Szkolenia">
    <ng-template matTabContent>
      <div fxLayout="column">
        <div fxLayout="row">
          <button *ngIf="(userPermissions | async).ofwca.read_report" [disabled]="!(userPermissions | async).ofwca.read_report"  mat-raised-button class="add-button" (click)="downloadMeetingReport()"><mat-icon>download</mat-icon>  Pobierz raport </button>
        </div>

        <app-ofwca-meeting-list
          [ofwca]="ofwca"
        ></app-ofwca-meeting-list>

      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Notatki"  *ngIf="(userPermissions | async).note.limited_read">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).note.limited_read" mat-stroked-button color="primary" class="add-button" (click)="addNote()"><mat-icon>add</mat-icon> Dodaj notatkę</button>

      <app-note-list [notes]="notes" (changed)="loadNotes()"></app-note-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Linki afiliacyjne">
    <ng-template matTabContent>
      <div class="button-row">
        <button
          [disabled]="!(userPermissions | async).partner.admin_root"
          mat-stroked-button
          color="primary"
          class="add-button"
          (click)="addAffiliateCod()">
          <mat-icon>add</mat-icon> Wygeneruj kod
        </button>

        <button
          *ngIf="(userPermissions | async).ofwca.read_report"
          (click)="downloadAffiliateLinkRaport()"
          [disabled]="!(userPermissions | async).ofwca.read_report"
          mat-raised-button
          class="report-button">
          <mat-icon>download</mat-icon>
          <span>Pobierz raport</span>
        </button>
      </div>
      <app-affiliate-code-list
        [affiliateCodes]="affiliateCode"
        (loadAffiliate)="loadAffiliateCode()"
        [excludeColumns]="['contactDetails', 'status','concludeDate']">
      </app-affiliate-code-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [ofwca]="ofwca"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
